import * as React from "react";
import {Form, InputGroup} from "react-bootstrap";
import {queryStringToHash, updateQueryString} from "./lib/utils";
import { v1 as uuidv1 } from 'uuid';

export default class FilterCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({},
            {value: this.props.value});
        console.log(props);
    }
    onCheckStatusChange = (value) => {
        value = value === 'true';
        value = !value;
        this.setState({value: value});
        const params = {
            ...queryStringToHash()
        };
        params[this.props.name] = value ? 1 : 0;
        $.ajax({
            type: 'GET',
            url: this.props.url,
            data: params}).done(() => updateQueryString(params))
    };
    render() {
        return <InputGroup>
            <Form.Group controlId={`filter-checkbox-${uuidv1()}`}>
                <Form.Check type="checkbox" label={this.props.label}
                            onChange={(e) => {this.onCheckStatusChange(e.target.value)}}
                            checked={this.state.value}
                            value={this.state.value}
                />
            </Form.Group>
        </InputGroup>;
    }
}